import { createFileRoute } from '@tanstack/react-router'

import { exportReportDocument } from '@/components/report-viewer/export'
import { ReportPage } from '@/components/reports/report-page'
import { CashbookReport } from '@/components/reports/cashbook/cashbook-report'
import { validateCashbookReportSearch } from '@/components/reports/cashbook/cashbook-report-search'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/reports/cashbook')(
    {
        validateSearch: validateCashbookReportSearch,
        component: CashbookReportPage,
    },
)

function CashbookReportPage() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const { hasPermission } = useAuth()
    return (
        <ReportPage title={m.cashbook_report_page_title()}>
            <CashbookReport
                search={search}
                onSearchChange={(next) =>
                    void navigate({
                        search: (prev) => ({ ...prev, ...next }),
                        replace: true,
                    })
                }
                // Chi tiết khoản chi là popup sửa ở màn Khoản chi.
                canOpenExpense={hasPermission('expenses.write')}
                exportDocument={
                    hasPermission('reports.export')
                        ? exportReportDocument
                        : undefined
                }
            />
        </ReportPage>
    )
}
